var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrevix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7901 9.36442V12.3508L10.0547 15.8062L4.29575 12.3892L4.30403 9.46386L2.41455 8.27051V13.5246L10.0547 17.9831L17.5967 13.5743V8.27051L15.7901 9.36442Z",
    fill: "url(#paint0_linear_365_7907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0056 2.22097L12.5581 3.72924L14.3979 2.58561L10.0056 0L5.63 2.60218L7.45319 3.72924L10.0056 2.22097Z",
    fill: "url(#paint1_linear_365_7907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 0.12207V3.72966L1.23778 4.4755V6.77371L7.46975 10.4864L6.32048 11.2379L10.0388 13.4035L13.6573 11.2156L12.5302 10.4645L18.7403 6.76277V4.4755L20 3.72966V0.12207L10.6739 5.66886L10 5.29328L9.35923 5.66886L0 0.12207Z",
    fill: "url(#paint2_linear_365_7907)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_365_7907",
    x1: 10.0053,
    y1: 8.27051,
    x2: 10.0053,
    y2: 17.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077DB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_365_7907",
    x1: 10.0136,
    y1: 0,
    x2: 10.0136,
    y2: 3.72924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077DB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_365_7907",
    x1: 10,
    y1: 13.4035,
    x2: 10,
    y2: 0.12207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0F49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevix);
export default __webpack_public_path__ + "static/media/iconPrevix.f838a1ce775a8380cbee7a54a83ddc06.svg";
export { ForwardRef as ReactComponent };